import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';

//constants

//validators
import { dropDownValidator, emailValidator } from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator } from '../../validators/CustomValidators';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'
import * as enums from '../../enums/index'
import * as util from '../../util/index'

//constants
import { Constants } from '../../constants/Constants';

//components

//base
import { BaseControlGroupComponent } from '../../baseclasses/BaseControlGroup.component';
import { CustomersAutoCompleteComponent } from '../Customers/CustomersAutoComplete.component';
import { CustomerGridComponent } from '../Grids/CustomerGrid.component';
import { e } from '@angular/core/src/render3';
import { FSVCustomerGridComponent } from '../Grids/FSVCustomerGrid.component';
import { UpdateNeededDropdownComponent } from '../DomainData/UpdateNeededDropdown.component';
import { PayerTypeDropdownComponent } from '../DomainData/PayerTypeDropdown.component';
//import { timeStamp } from 'core-js/core/log';

@Component({
    selector: 'my-payer-linkage-details',
    templateUrl: './PayerLinkageDetails.component.html',
    providers: [{ provide: BaseControlGroupComponent, useExisting: forwardRef(() => PayerLinkageDetailsComponent) }]
})
export class PayerLinkageDetailsComponent extends BaseControlGroupComponent {

    public form: FormGroup;
    payerLinkageInfo: ent.PayerLinkageInfo = new ent.PayerLinkageInfo();
    accountGroup: string = Constants._ACCOUNT_GROUP_PAYER;
    customers: ent.Customer[];
    request: ent.Request;
    fullServiceCustomers: ent.FullServiceCustomer[];
    requestUtil: util.RequestUtil;

    @Input() public showLinkToSelf: boolean;
    @Input() public disableNewPayer: boolean;
    @Input() public showCustomerType: boolean;
    @Input() public showPayerType: boolean;
    @Input() public showUpdateNeeded: boolean;

    @Input() public requireCustomerType: boolean;
    @Input() public requirePayerType: boolean;
    @Input() public requireUpdateNeeded: boolean;

    @Input() public updateNeededValue: number;
    @Input() public disableUpdateNeeded: boolean;

    @ViewChild('existingPayerCustomerAC') public existingPayerCustomerAC: CustomersAutoCompleteComponent;
    @ViewChild('newPayerCustomerAC') public newPayerCustomerAC: CustomersAutoCompleteComponent;
    @ViewChild(CustomerGridComponent) public customerGridComponent: CustomerGridComponent;
    @ViewChild(PayerTypeDropdownComponent) public payerTypeDropdownComponent: PayerTypeDropdownComponent;
    @ViewChild(FSVCustomerGridComponent) public fsvCustomerGridComponent: FSVCustomerGridComponent;
    @ViewChild(UpdateNeededDropdownComponent) public updateNeededDropdownComponent: UpdateNeededDropdownComponent;


    setDates() { }

    setRequestInfo(request: ent.Request) {
        this.payerLinkageInfo = request.PayerLinkageInfo;
        this.request = request;

        this.requestUtil.populateCustomerAutoComplete(this.existingPayerCustomerAC, this.payerLinkageInfo.ExistingPayerNumber);
        this.requestUtil.populateCustomerAutoComplete(this.newPayerCustomerAC, this.payerLinkageInfo.NewPayerNumber);

        this.getCustomersForPayerNumber();
    }

    constructor(fb: FormBuilder, private customerService: serv.CustomerService) {
        super();
        this.requestUtil = new util.RequestUtil(this.customerService);
        let group = {
            'customerType': '',
            'payerType': '',
            'updateNeeded': '',
            'existingPayer': '',
            'newPayer': ''
        };

        this.form = fb.group(group);

    }


    ngOnInit(): void {
        if (this.requirePayerType) {
            this.form.controls.payerType.setValidators(Validators.required);
        }
        if (this.requireUpdateNeeded) {
            this.form.controls.updateNeeded.setValidators(Validators.required);
        }
        this.setUpdateNeededValue();

    }

    setUpdateNeededValue() {
        if (this.updateNeededValue) {
            this.payerLinkageInfo.UpdateNeededID = this.updateNeededValue;
        }
    }

    customerTypeChange(event: any) {
        this.payerLinkageInfo.CustomerTypeID = event;
        this.payerTypeDropdownComponent.disabled = false;
        if (this.payerLinkageInfo.CustomerTypeID == enums.CustomerTypeEnum.DSD){
            this.payerTypeDropdownComponent.value = enums.PayerTypeEnum.Payer;
            this.payerTypeDropdownComponent.disabled = true;
        }
    }

    payerTypeChange(event: any) {
        this.payerLinkageInfo.PayerTypeID = event;
    }

    updateNeededChange(event: any) {
        this.payerLinkageInfo.UpdateNeededID = event;
    }

    useFullServiceCustomers(): boolean {
        return this.payerLinkageInfo.CustomerTypeID === enums.CustomerTypeEnum.FullService;
    }

    selectedNewPayerNumberChanged(customerNumbers: string[]) {
        if (customerNumbers && customerNumbers.length > 0) {
            if (this.useFullServiceCustomers()) {
                var filter: filters.CustomerFilter = { ZQCustomerNumber: customerNumbers[customerNumbers.length - 1] };
                this.customerService.getFullServiceCustomers(filter).subscribe(x => {
                    if (x && x.length > 0) {
                        this.payerLinkageInfo.NewPayerNumber = x[0].ZQCustomerNumber;
                    }
                    else {
                        this.payerLinkageInfo.NewPayerNumber = "";
                    }
                });
            }
            else {
                var filter: filters.CustomerFilter = { CustomerNumber: customerNumbers[customerNumbers.length - 1] };
                this.customerService.getCustomers(filter).subscribe(x => {
                    if (x && x.length > 0) {
                        this.payerLinkageInfo.NewPayerNumber = x[0].CustomerNumber;
                    }
                    else {
                        this.payerLinkageInfo.NewPayerNumber = "";
                    }
                });
            }
            
        }
        else {
            this.payerLinkageInfo.NewPayerNumber = "";
        }

    }

    selectedExistingPayerNumberChanged(customerNumbers: string[]) {
        if (customerNumbers && customerNumbers.length > 0) {
            if (this.useFullServiceCustomers()) {
                var filter: filters.CustomerFilter = { ZQCustomerNumber: customerNumbers[customerNumbers.length - 1] };
                this.customerService.getFullServiceCustomers(filter).subscribe(x => {
                    if (x && x.length > 0) {
                        this.payerLinkageInfo.ExistingPayerNumber = x[0].ZQCustomerNumber;
                        this.getCustomersForPayerNumber();
                    }
                    else {
                        this.payerLinkageInfo.ExistingPayerNumber = "";
                    }
                });
            }
            else {
                let customerNumber = customerNumbers[customerNumbers.length - 1];
                var filter: filters.CustomerFilter = { CustomerNumber: customerNumber, PYPayerNumber: customerNumber };
                this.customerService.getCustomers(filter).subscribe(x => {
                    if (x && x.length > 0) {
                        this.payerLinkageInfo.ExistingPayerNumber = x[0].PYPayerNumber;
                        this.getCustomersForPayerNumber();
                    }
                    else {
                        this.payerLinkageInfo.ExistingPayerNumber = "";
                    }
                });

            }
        }
        else {
            this.payerLinkageInfo.ExistingPayerNumber = "";
            if (this.useFullServiceCustomers()) {
                this.fsvCustomerGridComponent.records = [];
                this.fsvCustomerGridComponent.selectedRecords = [];
            }
            else {
                this.customerGridComponent.records = [];
                this.customerGridComponent.selectedRecords = [];
            }

        }

    }

    getCustomersForPayerNumber() {
        let payerNumber = this.payerLinkageInfo.ExistingPayerNumber;
        if (!payerNumber || payerNumber == ""){
            return;
        }
        if (this.useFullServiceCustomers()) {
            var filter: filters.CustomerFilter = { ZQCustomerNumber: payerNumber };
            this.customerService.getFullServiceCustomers(filter).subscribe(x => {
                this.fullServiceCustomers = x;
                this.fsvCustomerGridComponent.records = x;
                this.fsvCustomerGridComponent.selectedRecords = [];
                for (var rec of x) {
                    var payerLinkageCustomer = this.request.PayerLinkageCustomers.filter( x=> x.CustomerNumber == rec.CustomerNumber)[0];
                    if (payerLinkageCustomer) {
                        this.fsvCustomerGridComponent.selectedRecords = [...this.fsvCustomerGridComponent.selectedRecords, rec];
                        rec.LinkToSelf = payerLinkageCustomer.LinkToSelf;
                    }
                }
            });
        }
        else {
            var filter: filters.CustomerFilter = { PYPayerNumber: payerNumber };
            this.customerService.getCustomers(filter).subscribe(x => {
                this.customers = x;
                this.customerGridComponent.records = x;
                this.customerGridComponent.selectedRecords = [];
                for (var rec of x) {
                    var payerLinkageCustomer = this.request.PayerLinkageCustomers.filter( x=> x.CustomerNumber == rec.CustomerNumber)[0];
                    if (payerLinkageCustomer) {
                        this.customerGridComponent.selectedRecords = [...this.customerGridComponent.selectedRecords, rec];
                        rec.LinkToSelf = payerLinkageCustomer.LinkToSelf;
                    }
                }
            });
        }
    }

    getCustomerNumbers(): string {
        if (this.useFullServiceCustomers()) {
            return this.fsvCustomerGridComponent.selectedRecords.map(function (x) {
                return x.CustomerNumber;
            }).join(",");
        }
        else {
            return this.customerGridComponent.selectedRecords.map(function (x) {
                return x.CustomerNumber;
            }).join(",");
        }


    }

    getPayerLinkageCustomers(): ent.PayerLinkageCustomer[] {
      var records: ent.PayerLinkageCustomer[] = [];
      if (this.useFullServiceCustomers()) {
          for (var fsvCust of this.fsvCustomerGridComponent.selectedRecords) {
            records.push({CustomerNumber: fsvCust.CustomerNumber, LinkToSelf: fsvCust.LinkToSelf});
          }
      }
      else {
          for (var cust of this.customerGridComponent.selectedRecords) {
            records.push({CustomerNumber: cust.CustomerNumber, LinkToSelf: cust.LinkToSelf});
          }
      }
      return records;

    }

}